import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import style from './style.css'

const DEFAULT_POPUP_WIDTH = 950
const DEFAULT_POPUP_HEIGHT = 700

export default class ImagePopup extends Component {
  componentDidMount () {
    _.forEach(this.refs.container.getElementsByTagName('img'), (imgElement) => {
      // get the actual natural image size instead of the rendered space taken by the image
      const imgWidth = imgElement.naturalWidth
      const imgHeight = imgElement.naturalHeight

      // set up the dimensions of the popup, based on the ratio of the image
      let popupWidth
      let popupHeight
      if (imgWidth / DEFAULT_POPUP_WIDTH > imgHeight / DEFAULT_POPUP_HEIGHT) {
        popupWidth = Math.min(imgWidth, DEFAULT_POPUP_WIDTH)
        popupHeight = imgHeight / imgWidth * popupWidth
      } else {
        popupHeight = Math.min(imgHeight, DEFAULT_POPUP_HEIGHT)
        popupWidth = imgWidth / imgHeight * popupHeight
      }
      popupWidth = popupWidth || DEFAULT_POPUP_WIDTH
      popupHeight = popupHeight || DEFAULT_POPUP_HEIGHT

      // wrap the img around an anchor tag that creates a popup
      const imgHtml = imgElement.outerHTML
      imgElement.outerHTML =
        `<a
          href="${imgElement.src}"
          onclick="window.open('${imgElement.src}','popup','width=${popupWidth},height=${popupHeight}');return false;"
        >` +
        imgHtml +
        '</a>'
    })
  }

  render () {
    return (
      <div ref="container" className={style.container}>
        {this.props.children}
      </div>
    )
  }
}

ImagePopup.propTypes = {
  children: PropTypes.node
}
